export default __webpack_public_path__ + "static/037-a5375e8071770b942014a3a8e14c2338.png";